import React from "react";
import "./Chemical.css";

function Chemical() {
  return (
    <div className="chemicalmain">
      <div className="feedbackch">
        <div className="chemicalpp">
          <p>Chemical & fertilizer</p>
          <div>
            {/* <p className="cp3"><abbr title="Go To Swajit Engineering Pvt.Ltd">Swajit Engineering Pvt.Ltd:/</abbr>
        <a href="https://www.swajit.com/"></a> >Chemical & fertilizer</p> */}
          </div>
        </div>
        <div className="section9">
          <iframe
            width="340"
            height="220"
            src="https://www.youtube.com/embed/HyiNDAV5ywI"
            title="Super Phospate Reclaimer application"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Chemical;
